// Adviser üst bar ikonları — MVC adminblank.html üst barı BİREBİR:
// 5 ikon, her biri MVC'deki gibi KENDİ account_notes?filter_type=X sayfasına gider.
// Sayaçlar: Account.get_notes() → /orthero-api/v2/adviserprofile/ → data.header_counts
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Badge, Tooltip, Stack } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InboxIcon from '@mui/icons-material/Inbox';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

// MVC adminblank.html L253-427: 5 buton → 5 link (?filter_type=...)
const ICONS = [
    { key: 'doctor_notes', title: 'Hekim Mesajları', Icon: ChatBubbleOutlineIcon },
    { key: 'generelnotes', title: 'Genel Mesajlar', Icon: MailOutlineIcon },
    { key: 'adviserandrevision', title: 'Danışman Görüşü / Revizyon', Icon: InboxIcon },
    { key: 'impressionabout', title: 'Ölçü Hakkında', Icon: NotificationsNoneIcon },
    { key: 'importantnotes', title: 'Önemli Notlar', Icon: SentimentDissatisfiedIcon },
];

const AdviserHeaderIcons = () => {
    const navigate = useNavigate();
    const [counts, setCounts] = useState(null);

    useEffect(() => {
        const load = () => axios.get('/orthero-api/v2/adviserprofile/')
            .then((res) => {
                // header_counts cevabın üst seviyesinde ('data' ile kardeş)
                const hc = res.data?.header_counts || res.data?.data?.header_counts;
                console.log('[AdviserHeaderIcons] header_counts:', hc);
                setCounts(hc || null);
            })
            .catch((err) => console.error('[AdviserHeaderIcons] adviserdprofile hatası:', err?.response?.status, err?.response?.data));
        load();
        // Sayfa değişimlerinde sayaçları tazele (okundu işaretlerinden sonra düşsün)
        const interval = setInterval(load, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Stack spacing={2} direction="row">
            {ICONS.map(({ key, title, Icon }) => (
                <Tooltip key={key} title={title}>
                    <Badge
                        onClick={() => navigate(`/adviser-notifications?filter_type=${key}`)}
                        style={{ cursor: 'pointer' }}
                        badgeContent={counts ? (counts[key] || 0) : 0}
                        max={99}
                        color="secondary">
                        <Icon style={{ fontSize: '26px' }} color="action" />
                    </Badge>
                </Tooltip>
            ))}
        </Stack>
    );
};

export default AdviserHeaderIcons;
